<template>
<div class="ghost-resizable" :style="cssVars">
  <vue-resizable 
    :minWidth="cardWidths[0].value - 20"
    :width="containerWidth" 
    :active="['r']"
    :customTrigger="triggerKey"
    @resize:move="onResizeMove"
    @resize:end="onResizeEnd"
  >
    <div class="resizable-content">
      <slot></slot>
    </div>
  </vue-resizable>
</div>
</template>

<script>
import VueResizable from './vue-resizable.vue'

export default ({
  name: 'resizeableContainer',
  components: {VueResizable},
  props: ['width', 'cardWidths', 'cardId'],
  data () {
    return {
      containerWidth: '100%',
      ghostWidth: this.width,
      triggerKey: undefined,
      isResizing: false
    }
  },
  computed: {
    cssVars () {
      return {
        '--ghost-width': `${this.ghostWidth}%`,
        '--ghost-background': this.isResizing ? 'rgba(0, 0, 0, 0.05)' : 'none'
      }
    }
  },
  methods: {
    onResizeEnd () {
      //console.log(data)
      this.isResizing = false
      this.containerWidth = '100%'
      this.triggerKey = Math.random()

      this.$emit('resize-end', { card_id: this.cardId, final_width: this.ghostWidth })
    },
    onResizeMove (data) {
      //console.log(data)
      this.isResizing = true
      for (const cardWidth of this.cardWidths) {
        if (data.width <= cardWidth.value) {
          console.log(`Setting to ${cardWidth.percent}`)
          this.ghostWidth = cardWidth.percent
          break
        }
      }

      this.$emit('resize-move', data)
    }
  }
})
</script>

<style scoped>
  .resizable-component {
    height: auto !important;
  }

  .resizable-content {
    width: 100%;
    min-height: 100%;
    position: relative;
    top: 0;
    left: 0;
  }

  .ghost-resizable {
    width: calc(var(--ghost-width) - 6px);
    background: var(--ghost-background);
  }
</style>
